class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    /*
    this.notification.addEventListener("pointerover", () => {
      document.body.style.overflowY = "hidden";
    });

    this.notification.addEventListener("pointerout", () => {
      document.body.style.overflowY = "initial";
    });
    */

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    /*
    window.addEventListener("scroll", () => {
      let ua = navigator.userAgent;
      if (
        (ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
        ua.indexOf("Mobile") > 0
      ) {
      }
    });
    */

    const checkboxes = this.querySelectorAll('input[type="checkbox"]');
    const submitButton = this.querySelectorAll('button[type="submit"]');

    function updateSubmitButtonState() {
      let isChecked = false;
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          isChecked = true;

          // For Safari 15 (Safari 15 cannot use :has selector)
          checkbox.parentElement.classList.add("notification-selected");
        } else {
          checkbox.parentElement.classList.remove("notification-selected");
        }
      });

      if (document.getElementById("cart-notification-submit") != null) {
        document.getElementById("cart-notification-submit").disabled =
          !isChecked;

        if (!isChecked) {
          document.getElementById(
            "cart-notification-submit"
          ).style.opacity = 0.5;
        } else {
          document.getElementById("cart-notification-submit").style.opacity = 1;
        }
      }
    }

    checkboxes.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.addEventListener("change", updateSubmitButtonState);
      } else {
        checkbox.parentElement.classList.add("notification-disabled");
      }
    });

    updateSubmitButtonState();
  }

  open() {
    this.notification.classList.add(
      "notification-animate",
      "notification-active"
    );

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    const checkboxes = this.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    document.getElementById("cart-notification-submit").disabled = true;
    document.getElementById("cart-notification-submit").style.opacity = 0.5;

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("notification-active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
